<template>
  <div class="c-head" v-if="title">
    <h1 class="c-head__title" v-if="!isSubtitle && !isStrong">
      {{ title }}
      <strong class="c-head__strong" v-if="strong">
        {{ strong }}
      </strong>
    </h1>
    <div class="c-head c-head--gray" v-if="isSubtitle">
      <h2 class="c-head__subtitle">
        {{ title }}
      </h2>
    </div>
    <div class="c-head c-head--gray c-head--inline" v-if="isStrong">
      <h2 class="c-head__subtitle">
        {{ title }}
      </h2>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
export default {
  name: 'Head',
  data() {
    return {
      title: this.dataTitle ? this.dataTitle : '',
      strong: this.dataStrong ? this.dataStrong : '',
      isSubtitle: this.dataIsSubtitle ? this.dataIsSubtitle : false,
      isStrong: this.dataIsInline ? this.dataIsInline : false
    };
  },
  props: {
    dataTitle: String,
    dataStrong: String,
    dataIsSubtitle: Boolean,
    dataIsInline: Boolean
  }
};
</script>
<style lang="scss">
@import '@/assets/scss/essentials/essentials.scss';
@import './head';
</style>
